import { render, staticRenderFns } from "./monitoring3Detail.vue?vue&type=template&id=c2aa22f8"
import script from "./monitoring3Detail.vue?vue&type=script&lang=js"
export * from "./monitoring3Detail.vue?vue&type=script&lang=js"
import style0 from "./monitoring3Detail.vue?vue&type=style&index=0&id=c2aa22f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports